import { NgModule } from '@angular/core';
import { RouterModule, Routes, UrlMatchResult, UrlSegment } from '@angular/router';
import { EpdComponent } from './modules/epd/epd/epd.component';
import { MollieRedirectCatcherComponent } from './modules/mollie-redirect/mollie-redirect-catcher/mollie-redirect-catcher.component';
import { MaterialModule } from './material.module';
import { IframeDialogComponent } from './modules/cases/components/iframe-dialog/iframe-dialog.component';
import { LoginComponent } from './modules/login/pages/login/login.component';
import { MainComponent } from './modules/main/pages/main/main.component';
import { ManagementComponent } from './modules/management/management/management.component';
import { roleGuard } from '@/core';
import { userRoles } from '@/constants/roles';

export function enAndnlPrefixMatcher(segments: UrlSegment[]): UrlMatchResult | null {
  if (segments.length > 0 && (segments[0].path === 'en' || segments[0].path === 'nl')) {
    return {
      consumed: [segments[0]],
      posParams: {},
    };
  }
  return null;
}

const routes: Routes = [
  {
    matcher: enAndnlPrefixMatcher,
    redirectTo: '',
    pathMatch: 'full',
  },
  {
    path: '',
    component: MainComponent,
    children: [
      {
        path: '',
        loadChildren: () => import('../app/modules/home/home.module').then(m => m.HomeModule),
      },
      {
        path: 'home',
        pathMatch: 'full',
        redirectTo: '',
      },
      {
        path: 'account',
        loadChildren: () => import('../app/modules/account/account.module').then(m => m.AccountModule),
      },
      {
        path: 'beheer',
        component: ManagementComponent,
        canActivate: [roleGuard(userRoles.teacher, userRoles.admin, userRoles.superAdmin)],
        loadChildren: () => import('../app/modules/management/management.module').then(m => m.ManagementModule),
      },
      {
        path: 'epd',
        component: EpdComponent,
        loadChildren: () => import('../app/modules/epd/epd.module').then(m => m.EpdModule),
      },
      {
        path: 'casussen',
        loadChildren: () => import('../app/modules/cases/cases.module').then(m => m.CasesModule),
      },
    ],
  },
  {
    path: 'login',
    loadChildren: () => import('../app/modules/login/login.module').then(m => m.LoginModule),
  },
  {
    path: 'uitloggen',
    component: LoginComponent,
    loadChildren: () => import('../app/modules/login/login.module').then(m => m.LoginModule),
  },
  {
    path: 'mollie-redirect',
    component: MollieRedirectCatcherComponent,
  },
  {
    path: 'casussen/:id/iframe',
    component: IframeDialogComponent,
  },
];

@NgModule({
  imports: [MaterialModule, RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
